type CandidateNameInput = {
  firstName?: unknown;
  first_name?: unknown;
  lastName?: unknown;
  last_name?: unknown;
  middleName?: unknown;
  middle_name?: unknown;
  fullName?: unknown;
  name?: unknown;
  displayName?: unknown;
};

export const CONTACTS_OPENED_LABEL = 'Контакты открыты';

function normalizeText(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.replace(/\s+/g, ' ').trim();
  return trimmed || null;
}

function pickText(...values: unknown[]): string | null {
  for (const value of values) {
    const normalized = normalizeText(value);
    if (normalized) return normalized;
  }
  return null;
}

function parseUrl(rawUrl: string): { protocol: string; hostname: string; pathname: string; href: string } | null {
  if (typeof document !== 'undefined' && typeof document.createElement === 'function') {
    const link = document.createElement('a');
    link.href = rawUrl;
    return {
      protocol: link.protocol,
      hostname: link.hostname,
      pathname: link.pathname,
      href: link.href,
    };
  }

  try {
    const url = new URL(rawUrl);
    return {
      protocol: url.protocol,
      hostname: url.hostname,
      pathname: url.pathname,
      href: url.toString(),
    };
  } catch {
    return null;
  }
}

export function pickSafeHHResumeUrl(candidate: Record<string, unknown> | null | undefined): string | null {
  const rawUrl = pickText(
    candidate?.alternate_url,
    candidate?.alternateUrl,
    candidate?.resumeUrl,
    candidate?.resume_url,
  );
  if (!rawUrl) return null;

  const url = parseUrl(rawUrl);
  if (!url) return null;

  const hostname = url.hostname.toLowerCase();
  const isHHHost = hostname === 'hh.ru' || hostname.endsWith('.hh.ru');
  const isResumePath = url.pathname.startsWith('/resume/');
  if (url.protocol !== 'https:' || !isHHHost || !isResumePath) {
    return null;
  }
  return url.href;
}

export function getShortLastName(lastName: unknown): string | null {
  const normalized = normalizeText(lastName);
  if (!normalized) return null;
  return Array.from(normalized).slice(0, 2).join('');
}

function formatFromParts(firstName: unknown, lastName: unknown): string | null {
  const first = normalizeText(firstName);
  if (!first) return null;

  const shortLastName = getShortLastName(lastName);
  return [first, shortLastName].filter(Boolean).join(' ');
}

function formatFromFullName(fullName: unknown): string | null {
  const normalized = normalizeText(fullName);
  if (!normalized) return null;

  const parts = normalized.split(' ').filter(Boolean);
  if (parts.length < 2) return normalized;

  const [lastName, firstName] = parts;
  return formatFromParts(firstName, lastName);
}

export function formatCandidateShortName(
  candidate: CandidateNameInput | null | undefined,
  fallback = 'Кандидат',
): string {
  if (!candidate) return fallback;

  const fromParts = formatFromParts(
    pickText(candidate.firstName, candidate.first_name),
    pickText(candidate.lastName, candidate.last_name),
  );
  if (fromParts) return fromParts;

  const fromFullName = formatFromFullName(
    pickText(candidate.fullName, candidate.name),
  );
  return fromFullName || pickText(candidate.displayName) || fallback;
}
